export const docCategories = {
  act_of_completion: 'Акт выполненных работ',
  invoice_payment: 'Счет на оплату',
  goods_invoice: 'Накладная на отпуск товара',
  account_invoice: 'Счет фактура',
  power_attorney: 'Доверенность',
  return_note: 'Возврат поставщику',
  salary_certificate: 'Справка о ЗП',
  certificate_of_employment: 'Справка c места работы',
  // reconciliation_statement: 'Акт сверки',
};

export const documentTypes = [
  { key: 'invoice_payment', value: 'Счет на оплату' },
  { key: 'act_of_completion', value: 'Акт выполненных работ' },
  { key: 'goods_invoice', value: 'Накладная на отпуск товара' },
  { key: 'account_invoice', value: 'Счет фактура' },
  { key: 'power_attorney', value: 'Доверенность' },
  { key: 'return_note', value: 'Возврат поставщику' },
  { key: 'salary_certificate', value: 'Справка о ЗП' },
  { key: 'certificate_of_employment', value: 'Справка c места работы' },
  // { key: 'reconciliation_statement', value: 'Акт сверки' },
];

export const docTypes = {
  incoming: 'Входящие',
  outgoing: 'Исходящие',
};

export const docStatuses = {
  PUBLISHED: { text: 'Опубликован', color: 'green' },
  DRAFT: { text: 'Черновик', color: '' },
};
